import React from 'react'
import PropTypes from 'prop-types'

const mapItemChildren = (item, itemEntities) => {
  if (item.items && itemEntities){
    return item.items.map(itemId => itemEntities[itemId] || {})
  }

  return item.items || []
}

const ItemWrapper = (props) => {
  const { item, itemEntities, render } = props

  return render({
    nestedItems: mapItemChildren(item, itemEntities),
  })
}

ItemWrapper.propTypes = {
  item: PropTypes.object,
  itemEntities: PropTypes.object,
  render: PropTypes.func.isRequired,
}

export default ItemWrapper
